import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

import {
  ActionPortal,
  DefaultActionButtons,
  Row,
  Col,
  Switch,
} from "components";

import { StepPropTypes } from "../../constants/propTypes";
import AddressForm from "../forms/address";

export default function Address(props) {
  const {
    theme,
    onSubmit,
    onCancel,
    initialValues: { address },
  } = props;

  const {
    control,
    errors,
    formState,
    handleSubmit,
    register,
    setValue,
    trigger,
    watch,
  } = useForm({
    mode: "all",
    defaultValues: address,
  });

  const { isValid } = formState;

  const submitForm = (e) => {
    e.preventDefault();

    handleSubmit(onSubmit)();
  };

  const useSameAddress = watch("useSameAddress");
  const allFields = watch();

  const [sameAddressSwitch, setSameAddressSwitch] = useState(useSameAddress);
  const previousFieldsRef = useRef({});

  useEffect(() => {
    if (sameAddressSwitch) {
      const updatedFields = Object.keys(allFields)
        .filter(key => key.startsWith("matrix"))
        .reduce((updates, matrixKey) => {
          const deliveryKey = matrixKey.replace("matrix", "delivery");
          const currentValue = allFields[matrixKey];
          const previousValue = previousFieldsRef.current[matrixKey];

          if (currentValue !== previousValue) {
            updates[deliveryKey] = currentValue;
          }
          return updates;
        }, {});

      if (Object.keys(updatedFields).length > 0) {
        Object.entries(updatedFields).forEach(([key, value]) => {
          setValue(key, value);
        });
        trigger();
      }
    }

    previousFieldsRef.current = { ...allFields };
  }, [allFields, sameAddressSwitch, setValue]);

  const changeSameAddressSwitch = () => {
    const newState = !sameAddressSwitch;
    setSameAddressSwitch(newState);

    if (newState) {
      const fields = watch();
      Object.keys(fields)
        .filter(key => key.startsWith("matrix"))
        .forEach(key => setValue(key.replace("matrix", "delivery"), fields[key]));
    } else {
      const deliveryFields = ["deliveryZipCode", "deliveryStreetAddress", "deliveryStreetNumber",
        "deliveryComplement", "deliveryNeighborhood", "deliveryState",
        "deliveryCity", "deliveryLandline", "deliveryMobile"];
      deliveryFields.forEach(field => setValue(field, ""));
    };
    trigger();
  };

  return (
    <form onKeyPress={(e) => e.key === "Enter" && submitForm(e)}>
      <h1
        style={{
          fontWeight: 430,
          fontSize: 24,
          marginBottom: 24,
        }}
      >
        Endereço da Matriz
      </h1>
      <AddressForm
        setValue={setValue}
        errors={errors}
        register={register}
        control={control}
        trigger={trigger}
        fieldPrefix="matrix"
        disableFields={false}
      />
      <article>
        <h1
          style={{
            fontWeight: 430,
            fontSize: 24,
            marginBottom: 10,
          }}
        >
          Endereço de Entrega dos equipamentos
        </h1>
        <p
          for="managerName"
          style={{
            fontSize: 14,
            marginBottom: 18,
          }}
        >
          Caso o seu contrato NÃO envolva equipamentos, marque em usar o mesmo
          da matriz.
        </p>
      </article>
      <Row style={{ marginBottom: "24px" }}>
        <Col>
          <Switch
            inline
            id="useSameAddress"
            name="useSameAddress"
            label="Usar o mesmo endereço da Matriz"
            innerRef={register}
            checked={sameAddressSwitch}
            onClick={changeSameAddressSwitch}
          />
        </Col>
      </Row>
      <AddressForm
        errors={errors}
        register={register}
        control={control}
        setValue={setValue}
        trigger={trigger}
        disableFields={useSameAddress}
        fieldPrefix="delivery"
      />
      <ActionPortal>
        <DefaultActionButtons
          theme={theme}
          isValid={isValid}
          backButtonStyle={{
            iconPosition: "left",
            border: "none",
            customBackgroundColor: "transparent",
            customIconColor: theme.colors.text.label,
            customTextColor: theme.colors.text.label,
            title: "Passo Anterior",
          }}
          nextButtonStyle={{
            customBackgroundColor: theme.newPalette.background.purple,
            customIconColor: theme.colors.text.white,
            customTextColor: theme.colors.text.white,
            title: "Próximo Passo",
          }}
          onCancel={onCancel}
          onSubmit={() => handleSubmit(onSubmit)()}
        />
      </ActionPortal>
    </form>
  );
}

Address.propTypes = StepPropTypes;
